


































import AbpBase from "../../../lib/abpbase"
import {Component, Watch} from "vue-property-decorator"
import {GetPatients} from "@/api/specialDictionary"
import {GetChargeCollectDetail, GetChargeCollects} from "@/api/charge"

@Component({
	components: {}
})
export default class Temp extends AbpBase {
	input = ''
	dates: Array<any> = []
	date: any = []
	data: any = []
	query = {
		PatientId: '',
		StartDate: '',
		EndDate: ''
	}
	detailData:any = []
	modal: any = {
		title: '',
		show: false
	}
	dateChange(e: any) {
		this.dates = e
		this.getData()
	}
	detailColumns = [
		{
			title: '日期',
			key: 'date',
			render:(h:any,p:any) => {
				return h('span', this.formatDateTime(p.row.date))
			}
		},
		{
			title: '单价',
			key: 'price'
		},
		{
			title: '数量',
			key: 'count'
		},
		{
			title: '金额',
			key: 'amount'
		}
	]
	patients: any = []
	tableLoading = false
	patientLoading = false
	created() {
		this.getPatients()
		const now = new Date()
		const monthFirstDay = new Date(now.getFullYear(), now.getMonth(), 1)
		this.dates = [this.formatDate(monthFirstDay), this.formatDate(now)]
		this.date = [this.formatDate(monthFirstDay), this.formatDate(now)]
	}
	patient:any = {}
	selectPatient(item:any){
		this.query.PatientId = item.id
		this.patient = item
	}
	/**
	 * @return 'yyyy-MM-dd HH:mm:ss'
	 * */
	formatDateTime(val: string) {
		if (val) {
			let arr = val.split('T')
			let arr1:any = arr[1].split(':')
			if (arr1 || arr1[2].indexOf('.') !== -1) {
				arr1[2] = arr1[2].split('.')[0]
			}
			return `${arr[0]} ${arr1[0]}:${arr1[1]}:${arr1[2]}`
		} else {
			return ''
		}
	}
	columns: any = [
		{
			key: 'itemName',
			title: '名称'
		},
		{
			key: 'price',
			title: '价格'
		},
		{
			key: 'count',
			title: '数量'
		},
		{
			key: 'amount',
			title: '金额'
		},
		{
			title: ' ',
			width: 120,
			render: (h: any, p: any) => {
				return this.showDetail(h, p)
			}
		}
	]
	async detail(row: any) {
		let res = await GetChargeCollectDetail({
			ItemType: row.itemType,
			ItemId: row.itemId,
			PatientId: this.query.PatientId,
			StartDate: this.dates[0],
			EndDate: this.dates[1]
		})
		this.detailData = res.objects
		this.modal.show = true
		this.modal.title = this.patient.patientName
	}
	get height() {
		return window.innerHeight - 200
	}
	async getPatients() {
		this.patientLoading = true
		this.query.PatientId = ''
		let res = await GetPatients({
			QueryString: this.input,
			SkipCount: 1,
			MaxResultCount: 10000
		})
		this.patients = res.items
		this.patientLoading = false
	}
	@Watch('query.PatientId')
	private async getData() {
		if (this.query.PatientId) {
			this.tableLoading = true
			let res = await GetChargeCollects({
				PatientId: this.query.PatientId,
				StartDate: this.dates[0],
				EndDate: this.dates[1]
			})
			this.data = res.objects
			if (this.data.length) {
				let sumRow:any = {
					count: '合计',
					amount: 0
				}
				this.data.forEach((item:any)=>{
					sumRow.amount += Number(item.amount)
				})
				sumRow.amount = sumRow.amount.toFixed(2)
				this.data.push(sumRow)
			}
			this.tableLoading = false
		}
	}
	visibleChange(value:boolean){
		if(!value){
			this.modal.show = false
		}
	}
	private showDetail(h: any, p: any) {
		if (p.index !== this.data.length - 1) {
			return h('Button', {
				props: {
					type: 'primary'
				},
				on: {
					click: () => {
						this.detail(p.row)
					}
				}
			}, '详情')
		} else {
			return h('span')
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/costManage/costSummary/index.vue